/* eslint-disable no-console */
<template>
    <pm-app-component hide-sidebar>
        <template slot="title">{{ $t('menu.support') }}</template>

         <div style="overflow: hidden;

            height: auto;
            width: 100%;
            min-height: Calc(100vh - 160px);
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;"
            >

                <div class="pm-support-page-icon pm-animation-fade-in-slide-down">
                    <template v-if="$packageName === 'com.denticalc.videos'">
                        <img alt="DentiCalc" src="/images/dc_1_150.png" >
                        <br/>
                        Videos <small>by DentiCalc</small>
                    </template>
                    <template v-else-if="$packageName === 'com.denticalc.photos'">
                        <img alt="DentiCalc" src="/images/dc_2_150.png" >
                        <br/>
                        Photos <small>by DentiCalc</small>
                    </template>
                    <template v-else-if="$packageName === 'com.denticalc.calculator'">
                        <img alt="DentiCalc" src="/images/dc_3_150.png" >
                        <br/>
                        Calculator <small>by DentiCalc</small>
                    </template>
                    <template v-else-if="$packageName === 'com.denticalc.calculationtool'">
                        <img alt="DentiCalc" src="/images/dc_4_150.png" >
                        <br/>
                        Smart <small>by DentiCalc</small>
                    </template>
                    <template v-else-if="$packageName === 'com.denticalc.4in1'">
                        <img alt="DentiCalc" src="/images/dc_4in1_150_150.png" @click="testReview">
                        <br/>
                        DentiCalc
                    </template>

                    <small class="pm-support-page-version">v{{ appVersion }}</small>
                </div>

                <div style="width: 80vw; text-align: center;" class="pm-support-page-buttons feedback-wrapper">

                    <a class="support-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 50ms" @click="openShare">
                        <span>{{ $t('support.recommend_to_others') }}</span>
                    </a>
                    <br/>

                    <a class="support-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 100ms" @click="openMail">
                        <span>{{ $t('support.send_feedback') }}</span>
                    </a>
                    <br/>





                    <a class="support-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 150ms" @click="gotoTermsAndConditions">
                        <span>{{ $t('support.terms_of_service') }}</span>
                    </a>
                    <br/>

                    <a class="support-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 200ms" @click="gotoPrivacyPolicy">
                        <span>{{ $t('support.privacy_protection') }}</span>
                    </a>
                    <br/>

                     <a class="support-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 250ms" @click="restorePurchases">
                        <span>Restore purchases</span>
                    </a>
                    <br/>

                    <!-- <a class="support-btn mb-3 pm-animation-fade-in-slide-down" style="--delay: 300ms" @click="$bus.$emit('promo-code-form:show')">
                        <span>Use promo code</span>
                    </a> -->

                </div>
            </div>
            <pm-promo-form />
    </pm-app-component>
</template>

<style scoped>
.support-btn {
    white-space: nowrap;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    max-width: 90vw;
    width: 300px;
    height: 36px;
    text-decoration: none;
    /*border: 1px solid #2962ff;*/
    box-shadow: 0 0 6px rgba(0,0,0,.08);
    color: #444;
    border-radius: 24px;
    padding-bottom: 0px;
    background: #fff;
    text-transform: uppercase;
    margin-bottom: 40px;
}
.support-btn span {
    font-size: 14px;
}
.pm-support-page-icon {
    margin-bottom: 20px;
    text-align: center;
    font-weight: 600;
    font-size: 16px;
}

.pm-support-page-icon img {
    width: 75px;
}
.pm-support-page-version {
    display: block;
    font-size: 11px;
    color: #aaa;
}

@media (min-width: 700px) {
    .pm-support-page-icon {
        font-size: 24px;
    }

    .pm-support-page-version {
        font-size: 15px;
    }

    .pm-support-page-icon img {
        width: 160px

    }

    .pm-support-page-buttons .support-btn {
        width: 400px;
        height: 44px;
    }


    .pm-support-page-buttons a span {
        font-size: 16px!important;
    }
}
</style>

<script>
import PmSimpleComponentLayout from "@/components/core/pm-simple-component-layout";
import { share } from '@/utils/device/share';
import ToolbarMixin from "../../extensions/mixins/mixin-toolbar";
import PmPromoForm from "../addons/promo-form";
import { IAPgetOfferings } from "@/utils/iap";

export default {
    components: {
        PmSimpleComponentLayout,
        PmPromoForm,
    },
    mixins: [
        ToolbarMixin,
    ],

    data: () => ({
        testCounter: 1,
        appVersion: window.appVersion,
    }),
    toolbar() {
        const items = [];

            items.push({
                active: true,
                mdi: "mdiHelpCircleOutline",
                text: "Support",
                callback: () => {
                    return false;
                },
            });

            items.push({
                mdi: "mdiCommentProcessingOutline",
                text: "F.A.Q.",
                callback: () => {
                    this.$router.push("/faq");
                },
            });

            items.push({
                mdi: "mdiHumanMaleBoard",
                text: "Tutorials",
                callback: () => {
                    this.$router.push("/tutorials");
                },
            });

            // items.push({
            //     mdi: "mdiWalletGiftcard",
            //     text: app.$t('iap.redeem-promo-code-menu'),
            //     callback: () => {
            //         this.$bus.$emit('promo-code-form:show');
            //     },
            // });

            // items.push({ placeholder: true });

            // items.push({ placeholder: true });

            items.push({
                back: true,
                callback: () => {
                    this.$router.push("/");
                },
            });


        return ([items]);
    },
    created() {
        this.registerBusEvent("flutter:paymentRestoreError", this.handleRestoreFailed);
        this.registerBusEvent("flutter:paymentRestoreSucceed", this.handleRestoreSucceed);
        this.registerBusEvent("flutter:paymentRestoreFailed", this.handleRestoreFailed);
    },
    methods: {
        restorePurchases() {
            window.IAP.restore();
            this.isRestoringPurchases = true;
        },
        handleRestoreSucceed(data) {
            // @TODO: use data instead getOfferings
            IAPgetOfferings(true);
            this.$bus.$emit('app.showSnackbar', {
                text: 'Restoring purchases completed',
            });
        },
        handleRestoreFailed() {
            this.$bus.$emit("app.showSnackbar", {text: this.$t("subscriptions.restore_error")});
        },
        async testReview() {
            // Show review modal only, if counter is pressed n * 10 times.
            if (this.testCounter++ % 10) return;

            if (localStorage.getItem('isDevMode') === "true") {
                localStorage.setItem('isDevMode', 'false');
                this.$bus.$emit("app.showSnackbar", {color: "red", text: 'Debug mode disabled'});
            } else {
                localStorage.setItem('isDevMode', 'true');
                this.$bus.$emit("app.showSnackbar", {color: "red", text: 'Debug mode enabled'});
            }

            this.$bus.$emit("debug:toggled");

            return;
        },
        simulateLoading() {
            // Enable loading state. Show loader icon.
            this.loading = true;

            // Disable loading state. Hide loader icon.
            setTimeout(() => (this.loading = false), 2000);
        },
        openMail() {
            this.$router.push("/feedback");
        },
        openShare() {
            this.simulateLoading();

            /**
             * Are you looking for a tool which help you during consultations?
             * Here is a useful dentist app that I use every day. Try the FREE version yourself.
             * Check out this dental app. Made my job easier.
             * Are you looking for a tool which help you during consultations? Here is my favorite:
             */

            const text = "Check out this dental app. Made my job easier. "; // this text will be used by most channels
            const subject = "Dental app for professionals"; // will be used only when shared in email
            // @ts-ignore
            const url = this.$isIOS()
                ? "https://apps.apple.com/us/app/id1537539049"
                : "https://play.google.com/store/apps/details?id=com.denticalc.demo";

            window.Tracker.setUserProperty('share', 1, {
                event_name: 'share',
                event_label: 'share',
                event_value: 1,
            });

            share(text, subject, url);
        },
        gotoTermsAndConditions() {
            this.$router.push("/terms-and-conditions");
        },
        gotoPrivacyPolicy() {
            this.$router.push("/privacy-policy");
        },
    },
};
</script>
